import React, { useEffect, useState } from 'react';
import { Filters, getAppliedFilter, setAppliedFilter } from '../services/localstorage.service';

/**
 * Custom hook to persist state in localStorage with proper initialization and synchronization.
 * @param storageKey - Key of the local storage.
 * @param defaultValue - Default value to use if no stored value exists.
 * @returns - Tuple containing the state value and setter function.
 */
export default function useStorageState<T>(
  storageKey: Filters | undefined,
  defaultValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  // Initialize state from localStorage, but only on initial render
  const [state, setState] = useState<T>(() => {
    if (!storageKey) return defaultValue;

    const storedValue = getAppliedFilter(storageKey);
    return storedValue?.data ? storedValue.data : defaultValue;
  });

  // Sync state to localStorage whenever it changes
  useEffect(() => {
    if (storageKey) {
      setAppliedFilter({
        key: storageKey,
        data: state
      });
    }
  }, [state, storageKey]);

  return [state, setState];
}
